import styled from 'styled-components';
import { useRouter } from 'next/router';
import { FlexCol, FlexJustifySpaceBetween } from 'components/primitives/flex';
import { BookingAddonItem } from 'components/booking/add-ons/BookingAddonItem';
import { dollarsNoCentsWithSymbol } from 'helpers/currency';
import { BookingAddOn } from 'swagger/models';
import Button from 'components/ui/Button/Button';
import { useCloseModal } from 'components/remodal/v2/hooks';

type ModalProps = {
  addonList: BookingAddOn[];
  isEdit?: boolean;
  totalCents: number;
};

const ViewSelectedAddonsModal = ({ addonList = [], isEdit = false, totalCents }: ModalProps) => {
  const router = useRouter();
  const closeModal = useCloseModal();

  const finalAddonList = addonList.filter((e) => (isEdit ? (e as BookingAddOn & { enabled: boolean }).enabled : true));

  const onEdit = async () => {
    const { query } = router;
    delete query.addons;
    await router.push({ query });
    closeModal();
  };

  return (
    <Wrapper gap="40px">
      <Heading>Add-ons</Heading>
      <MainContent gap="22px">
        {finalAddonList.map(({ description, display_short_price_type, price_cents, quantity, name: internalName }) => (
          <BookingAddonItem
            key={internalName}
            title={internalName}
            amount={quantity}
            price={Number(price_cents)}
            rate={display_short_price_type}
            description={description}
          />
        ))}
      </MainContent>
      <Footer>
        {isEdit && <EditButton onClick={onEdit} outline text="Edit add-ons" toUppercase type="button" />}
        <TotalPrice>Add-ons total {dollarsNoCentsWithSymbol(totalCents)}</TotalPrice>
      </Footer>
      {!isEdit && (
        <ContactInfo>
          To make edits to selected add-ons, please contact support at{' '}
          <PhoneLink href="mailto:contact@boatsetter.com">contact@boatsetter.com</PhoneLink>
        </ContactInfo>
      )}
    </Wrapper>
  );
};

export default ViewSelectedAddonsModal;

const PhoneLink = styled.a`
  font-weight: 600;
`;

const Wrapper = styled(FlexCol)`
  line-height: 1.4;
`;

const Heading = styled.p`
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 0;
`;

const MainContent = styled(FlexCol)``;

const Footer = styled(FlexJustifySpaceBetween)`
  align-items: center;
`;

const EditButton = styled(Button)`
  width: 153px;
`;

const TotalPrice = styled.p`
  font-weight: 700;
  line-height: 16px;
  margin-left: auto;
`;

const ContactInfo = styled.p`
  font-size: 14px;
  line-height: 1.6;
  border-top: 1px solid #8e969780;
  padding-top: 24px;
  margin-bottom: 0;
`;
